export const SETTLEMENT_TYPE_CITY = 'settlement_type.city';
